import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const SourceCredentialContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  padding: '20px 0px 20px 24px',
  [mobileMediaQuery]: {
    flex: 'initial',
    padding: 0,
  },
});

export const CredentialHeadings = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

export const CredentialHeading = styled.span({
  fontWeight: fontStyles.weights.medium,
});

export const CredentialSubHeading = styled.span({
  color: fontStyles.colors.tertiary,
  fontSize: fontStyles.sizes.xs,
  lineHeight: '16px',
});
